import Vue from "vue";
import Vuetify from "vuetify";
import router from "./router";
import Vuelidate from "vuelidate";
import Vuex from "vuex";

import API from "./api";

import VueFilters from "./filters/vueFilters"

import SessionService from './services/sessionService'
import TicketService from "./services/ticketService";
import InviteService from "./services/inviteService";
import ResourceService from "./services/resourceService";
import PinSwitchService from "./services/pinSwitchService";

import SessionGuard from "./guards/sessionGuard";
import TicketGuard from "./guards/ticketGuard";

import "@babel/polyfill"
import "./sass/app.scss";
import colors from "vuetify/lib/util/colors"

Vue.use(Vuetify);
Vue.use(Vuelidate);
Vue.use(Vuex);
Vue.filter('truncate', VueFilters.truncate);
Vue.component(
    "login-layout",
    require("./components/Layout.vue").default
);

Vue.prototype.$isDevEnviroment = process.env.NODE_ENV === 'development';
Vue.prototype.$api = new API();
Vue.prototype.$pinSwitchService = new PinSwitchService();
Vue.prototype.$sessionService = new SessionService(Vue.prototype.$api);
Vue.prototype.$ticketService = new TicketService(Vue.prototype.$api);
Vue.prototype.$inviteService = new InviteService(Vue.prototype.$api, Vue.prototype.$sessionService);
Vue.prototype.$resourceService = new ResourceService(Vue.prototype.$api, Vue.prototype.$sessionService);
Vue.prototype.$sessionGuard = new SessionGuard(Vue.prototype.$sessionService);
Vue.prototype.$ticketGuard = new TicketGuard(Vue.prototype.$ticketService);

new Vue(
    {
        store: new Vuex.Store({
            state: {
                loading: true
            },
            mutations: {
                loadingOff (state) {
                    state.loading = false
                },

                loadingOn (state) {
                    state.loading = true
                }
            }
        }),

        vuetify: new Vuetify({
            theme: {
                themes: {
                    light: {
                        primary: colors.orange,
                        secondary: colors.grey,
                        accent: colors.amber.base
                    },
                },
            },
        }),

        data: Object.assign(
            {
                ticket: false,
                resourceTypes: [],
                application: {},
                login: false
            }, {}
        ),

        router,

        created() {
            if (localStorage.login) {
                this.login = localStorage.login;
            }
        },
        watch: {
            '$route'(to) {
                document.title = to.meta.title || 'Launchpad'
            },
            login(newLogin) {
                if (newLogin) {
                    localStorage.login = newLogin;
                } else {
                    localStorage.removeItem("login");
                }
            },
        },
    }
).$mount("#app");

